import React from "react";
import { LogRenderContext } from "../LogRenderer";
import Resumed from "../common/Resumed";
import { getTargetGroupDetails } from "../utils";

const TargetGroupResumed = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, id, updatedBy, updatedAt } = getTargetGroupDetails(log);
  return <Resumed name={name} id={id} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default TargetGroupResumed;
